import { logger } from '../../../utils/logger'
import type { ServiceHandler } from './service-registry'
import { validateUrl } from './validateUrl'
import type { RedirectRequest, RedirectResponse } from '@custom-embedded-code-sdk/methods/redirect'

/**
 * REDIRECT service handler
 *
 * Handles requests to redirect to any http/https URL.
 * Validates that a URL is provided before performing the redirect.
 */
export const redirect: ServiceHandler<RedirectRequest, RedirectResponse> = async ({
  iframeId,
  messageId,
  payload,
  sendSuccessResponse,
  sendErrorResponse,
}) => {
  try {
    // Validate that payload is a string
    if (typeof payload !== 'string') {
      sendErrorResponse(iframeId, messageId, 'Missing URL for redirect')
      return
    }

    const url = payload

    // Validate URL format and security using validator package
    const validation = validateUrl(url)

    if (!validation.isValid) {
      logger('warn', 'CustomEmbeddedCode:redirect: Blocked dangerous URL scheme attempt', {
        context: { iframeId, messageId, payload, blockedUrl: url },
      })
      sendErrorResponse(iframeId, messageId, 'Invalid URL format')
      return
    }

    // Perform the redirect
    window.location.href = url

    // Note: This response may not be received due to the redirect
    sendSuccessResponse(iframeId, messageId, { redirected: true, url })
  } catch (error) {
    logger(
      'error',
      new Error('CustomEmbeddedCode:redirect: Error performing redirect', { cause: error }),
      {
        context: { iframeId, messageId, payload },
      },
    )
    sendErrorResponse(iframeId, messageId, 'Unable to perform redirect')
  }
}
